import { backendServices } from './AxiosInstances'

export const getPatient = (patientId: string) =>
  backendServices
    .get('/adm/user', { params: { patient_id: patientId } })
    .then(({ data }) => data.data)
    .catch(error => {
      throw error
    })
